import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { STORAGE_CMS, STORAGE_CMS_JWT, STORAGE_REFRESH_CMS_DATE } from './constants';

@Injectable({
  providedIn: 'root'
})
export class CmsAuthService {
  private loginSubject = new Subject<void>();

  constructor(private http: HttpClient, private router: Router) { }

  login(username: string, password: string) {
    return this.http.post<any>('/api/auth/authenticate-cms', { username, password })
      .pipe(map((res: any) => {
        // login successful is there's a jwt token in the response
        if (res && res.token) {
          localStorage.setItem(STORAGE_CMS_JWT, res.token)
          localStorage.setItem(STORAGE_CMS, res.username)
          localStorage.setItem(STORAGE_REFRESH_CMS_DATE, res.refresh_date)
          this.loginSubject.next();
          return
        } else {
          this.loginSubject.next();
          return 'Invalid username and password'
        }
      }))
  }

  logout(refresh?: boolean) {
    localStorage.removeItem(STORAGE_CMS_JWT)
    localStorage.removeItem(STORAGE_CMS)
    localStorage.removeItem(STORAGE_REFRESH_CMS_DATE)
    this.loginSubject.next();
    if (refresh) {
      this.router.navigate(['/cms', 'login'])
      location.reload()
    }
    return true;
  }

  watchLogin(): Observable<any> {
    return this.loginSubject.asObservable();
  }
}
